// extracted by mini-css-extract-plugin
export default {"root":"pk_iWv","bg":"xUlxGN"};